import { createReducer } from 'typesafe-actions';
import { purge } from '../auth/actions';
import {
  getAgreementDebt,
  getAgreementPortionDebt,
  getBilletDeal,
  getLinhaDigitavelDealBillet,
  setAgreementStatus,
} from './actions';

const INITIAL_STATE: AgreementState = {
  list: [],
  error: '',
  portions: [],
  billet: { nnumero: '', linhaDigitavel: '' } as GQL.IBillet,
  billetLine: { nnumero: '', linhaDigitavel: '' } as GQL.IBillet,
  status: '',
};

const agreementReducer = createReducer(INITIAL_STATE)
  .handleAction(purge, () => INITIAL_STATE)
  .handleAction(getAgreementDebt.success, (state, action) => ({
    ...state,
    list: action.payload,
    agreementDebtLoading: false,
  }))
  .handleAction(getAgreementDebt.request, (state, action) => ({
    ...state,
    agreementDebtLoading: true,
  }))
  .handleAction(getAgreementDebt.failure, (state, action) => ({
    ...state,
    error: action.payload,
    agreementDebtLoading: false,
  }))
  .handleAction(getAgreementPortionDebt.success, (state, action) => ({
    ...state,
    portions: action.payload,
    agreementPortionDebt: false,
  }))
  .handleAction(getAgreementPortionDebt.request, (state, action) => ({
    ...state,
    agreementPortionDebt: true,
  }))
  .handleAction(getAgreementPortionDebt.failure, (state, action) => ({
    ...state,
    error: action.payload,
    agreementPortionDebt: false,
  }))
  .handleAction(getBilletDeal.success, (state, action) => ({
    ...state,
    billet: action.payload,
  }))
  .handleAction(getBilletDeal.failure, (state, action) => ({
    ...state,
    billet: INITIAL_STATE.billet,
    error: action.payload,
  }))
  .handleAction(getLinhaDigitavelDealBillet.success, (state, action) => ({
    ...state,
    billetLine: action.payload,
  }))
  .handleAction(getLinhaDigitavelDealBillet.failure, (state, action) => ({
    ...state,
    billetLine: INITIAL_STATE.billetLine,
    error: action.payload,
  }))
  .handleAction(setAgreementStatus, (state, action) => ({
    ...state,
    status: action.payload,
  }));

export default agreementReducer;
